import { enumUIModes } from "../constants";
import { Globals } from "../CoreApp/Globals";

export function isInBoxLayoutEditor() {
  return Globals._uiConfig.GetUIMode() === enumUIModes.boxlayouteditor;
}
